import script from "./VirtualListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualListItem.vue?vue&type=script&setup=true&lang=js"

import "./VirtualListItem.vue?vue&type=style&index=0&id=1b627117&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b627117"]])

export default __exports__